module.exports = __webpack_public_path__ + "media/vid_body_feature5.05739f16.mp4";